import type { AdminStoredFile } from "@whatslly/types/integrations/SecureStorage";
import type { ProtectedFilesFilters } from "./IProtectedFilesStore";

export interface IProtectedFilesApi {
  // Both kinds — protected files and Tuvis Storage files — newest first, under one cursor.
  list(q: ProtectedFilesFilters & { cursor?: string }): Promise<{ files: AdminStoredFile[]; nextCursor?: string }>;
  // Resolves to the number of files revoked (0 or 1), and rejects when the server refuses.
  revoke(id: string): Promise<number>;
  // Tuvis Storage. Rejects when the server refuses.
  deleteFile(id: string): Promise<void>;
}

export const InjectProtectedFilesApi = Symbol.for("ProtectedFilesApi");
